module.exports = __webpack_public_path__ + "public/img/home_in1.4169f329.png";